import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import moment from 'moment';
import { useUser } from '../../utils/userContext';
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import useHandleErrors from '../../utils/user.utils';
import image1 from "../../assets/globalImgs/profile.png";



const Profile = () => {
    const [employee, setEmployee] = useState(null);
    const [employeePercentage, setEmployeePercentage] = useState(null);
    const [loading, setLoading] = useState(true);
    const { user } = useUser();
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const handleErrors = useHandleErrors();
    const token = localStorage.getItem("token");
    const hasFetchedRef = useRef(false);


    useEffect(() => {
        const getPersonalDetails = async () => {
            try {
                if (user) {
                    const path = `/getPersonalDetails?EmployeeId=${user?.EmployeeId}`;
                    const URL = process.env.REACT_APP_BE_URL + path;
                    const response = await axios.get(URL, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    })
                    if (response.status === 200) {
                        setEmployeePercentage(response.data)
                        setEmployee(response.data.onboardEmployeeDetails);
                        setLoading(false);
                    } else {
                        handleErrors(response);
                    }
                }
            } catch (error) {
                if (error.response) {
                    handleErrors(error.response);
                } else {
                    toast.error("Something went wrong. Please try again later.", {
                        position: toast.POSITION.TOP_CENTER,
                    });
                }
            } finally {
                setLoading(false);
            }
        }
        if (!hasFetchedRef.current) {
            getPersonalDetails();
            hasFetchedRef.current = true;
        }
    }, [user]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true)
        if (newPassword !== confirmPassword) {
            toast.error("New Password and Confirm Password do not match!", {
                position: toast.POSITION.TOP_CENTER,
            });
            return setLoading(false);;
        }

        if (!oldPassword || !newPassword || !confirmPassword) {
            toast.error("Please fill in all the fields!", {
                position: toast.POSITION.TOP_CENTER,
            });
            return setLoading(false);;
        }

        try {
            const path = "/resetPassword";
            const URL = process.env.REACT_APP_BE_URL + path;
            const response = await axios.post(URL,
                {
                    oldPassword,
                    newPassword,
                    OfficialEmail: employee.OfficialEmail
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

            if (response.status === 200) {
                toast.success("Password reset successful!", {
                    position: toast.POSITION.TOP_CENTER,
                });
                setOldPassword("");
                setNewPassword("");
                setConfirmPassword("")
            } else {
                handleErrors(response);
            }
        } catch (error) {
            if (error.response) {
                handleErrors(error.response);
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div id="preloading">
                <span className="loader"></span>
            </div>
        );
    }

    if (!employee) {
        return <div>Error loading employee data.</div>;
    }

    const calculateCompletionPercentage = () => {
        const personalInfoFields = [
            employeePercentage?.onboardEmployeeDetails?.Image ?? '',
            employeePercentage?.onboardEmployeeDetails?.FirstName ?? '',
            employeePercentage?.onboardEmployeeDetails?.LastName ?? '',
            employeePercentage?.onboardEmployeeDetails?.EmployeeId ?? '',
            employeePercentage?.onboardEmployeeDetails?.DateOfJoining ?? '',
            employeePercentage?.onboardEmployeeDetails?.OfficialEmail ?? '',
            employeePercentage?.onboardEmployeeDetails?.ContactNumber ?? '',
            employeePercentage?.onboardEmployeeDetails?.EmployeeType ?? '',
            employeePercentage?.onboardEmployeeDetails?.Department ?? '',
            employeePercentage?.onboardEmployeeDetails?.Designation ?? '',
            employeePercentage?.onboardEmployeeDetails?.UserAccessLevel ?? '',
            employeePercentage?.onboardEmployeeDetails?.DateOfBirth ?? '',
            employeePercentage?.onboardEmployeeDetails?.BloodGroup ?? '',
        ];

        const additionalInfoFields = [
            employeePercentage?.personalInformation?.personalDetails?.bank?.bankName ?? '',
            employeePercentage?.personalInformation?.personalDetails?.bank?.branchName ?? '',
            employeePercentage?.personalInformation?.personalDetails?.bank?.branchCode ?? '',
            employeePercentage?.personalInformation?.personalDetails?.bank?.accountNumber ?? '',
            employeePercentage?.personalInformation?.personalDetails?.bank?.accountType ?? '',
            employeePercentage?.personalInformation?.personalDetails?.bank?.swiftCode ?? '',
            employeePercentage?.personalInformation?.personalDetails?.family?.fatherName ?? '',
            employeePercentage?.personalInformation?.personalDetails?.family?.motherName ?? '',
            employeePercentage?.personalInformation?.personalDetails?.family?.birthCertificate ?? '',
            employeePercentage?.personalInformation?.personalDetails?.family?.spouseName ?? '',
            employeePercentage?.personalInformation?.personalDetails?.family?.marriageCertificate ?? '',
            employeePercentage?.personalInformation?.personalDetails?.family?.children ?? '',
            // Assuming there may be multiple children
            ...(employeePercentage?.personalInformation?.personalDetails?.family?.childrenDetails?.map(child => child?.ChildrenName ?? '') ?? []),
            employeePercentage?.personalInformation?.personalDetails?.education?.institutionName ?? '',
            employeePercentage?.personalInformation?.personalDetails?.education?.institutionCode ?? '',
            employeePercentage?.personalInformation?.personalDetails?.education?.institutionType ?? '',
            employeePercentage?.personalInformation?.personalDetails?.education?.qualification ?? '',
            employeePercentage?.personalInformation?.personalDetails?.education?.graduationDate ?? '',
            employeePercentage?.personalInformation?.personalDetails?.education?.grade ?? '',
            employeePercentage?.personalInformation?.personalDetails?.health?.medicalConditions ?? '',
            employeePercentage?.personalInformation?.personalDetails?.health?.knownChronicConditions ?? '',
            employeePercentage?.personalInformation?.personalDetails?.health?.knownChronicAllergies ?? '',
            employeePercentage?.personalInformation?.personalDetails?.health?.vaccinationStatus ?? '',
            employeePercentage?.personalInformation?.personalDetails?.health?.vaccinationType ?? '',
            employeePercentage?.personalInformation?.personalDetails?.health?.dateOfLastVaccination ?? '',
            employeePercentage?.personalInformation?.personalDetails?.health?.workRelatedInjuries ?? '',
            employeePercentage?.personalInformation?.personalDetails?.health?.dateOfIncident ?? '',
            employeePercentage?.personalInformation?.personalDetails?.health?.incidentDescription ?? '',
            employeePercentage?.personalInformation?.personalDetails?.health?.doYouHavePersonalDoctor ?? '',
            employeePercentage?.personalInformation?.personalDetails?.health?.doctorName ?? '',
            employeePercentage?.personalInformation?.personalDetails?.health?.doctorContact ?? '',
            employeePercentage?.personalInformation?.personalDetails?.health?.doctorEmail ?? '',
            employeePercentage?.personalInformation?.personalDetails?.health?.hospitalName ?? '',
            employeePercentage?.personalInformation?.personalDetails?.health?.healthCertificate ?? '',
            employeePercentage?.personalInformation?.personalDetails?.additionalInformation?.kin ?? '',
            employeePercentage?.personalInformation?.personalDetails?.additionalInformation?.passport ?? '',
            employeePercentage?.personalInformation?.personalDetails?.additionalInformation?.passportCopy ?? '',
            employeePercentage?.personalInformation?.personalDetails?.additionalInformation?.conductCertificates ?? '',
            employeePercentage?.personalInformation?.personalDetails?.additionalInformation?.referenceDetails ?? '',
            employeePercentage?.personalInformation?.personalDetails?.experience?.totalExperience ?? '',
            employeePercentage?.personalInformation?.personalDetails?.experience?.employerName ?? '',
            employeePercentage?.personalInformation?.personalDetails?.experience?.department ?? '',
            employeePercentage?.personalInformation?.personalDetails?.experience?.designation ?? '',
            employeePercentage?.personalInformation?.personalDetails?.experience?.managerName ?? '',
            employeePercentage?.personalInformation?.personalDetails?.experience?.managerEmail ?? '',
            employeePercentage?.personalInformation?.personalDetails?.experience?.startDate ?? '',
            employeePercentage?.personalInformation?.personalDetails?.experience?.endDate ?? '',
            employeePercentage?.personalInformation?.personalDetails?.experience?.location ?? '',
            // Assuming there may be multiple submitted documents
            ...(employeePercentage?.personalInformation?.personalDetails?.submittedDocuments ?? []),
        ];

        const allFields = [...personalInfoFields, ...additionalInfoFields];
        const filledFields = allFields.filter(field => field && field.trim() !== '').length;

        return Math.round((filledFields / allFields.length) * 100);
    };

    const completionPercentage = calculateCompletionPercentage();

    const handleClear = () => {
        setOldPassword('')
        setNewPassword('')
        setConfirmPassword('')
    }

    return (
        <div>
            {loading && (
                <div id="preloading">
                    <span className="loader"></span>
                </div>
            )}
            <div className="content-page">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="row mb-2">
                                <div className="col">
                                    <h3 className="title mb-2">My Profile</h3>
                                </div>
                                <div className="col-auto">
                                    <Link to={'/SubmitTimesheet'} data-extra-toggle="tab" data-target="#timesheet-pan" className="btn btn-primary mt-lg-0 mt-4">
                                        <i className="ri-calendar-schedule-fill"></i> Timesheet
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-8">
                            <div className="card mb-4">
                                <div className="card-body">
                                    <div className="row mt-3">
                                        <div className="col-lg-4 col-md-12">
                                            <div className="user-info">
                                                <div className="profile-detail">
                                                    <div className="user-profile-pic">
                                                        <img src={employee.Image ? employee.Image : image1} className="img-fluid" alt="Profile" />
                                                    </div>
                                                    {/* <label htmlFor="file" className="profile-pic-upload" title="Edit Photo">
                                                        <i className="ri-image-edit-fill"></i>
                                                        <input
                                                            type="file"
                                                            id="file"
                                                            style={{ display: 'none' }}
                                                            name="image"
                                                            accept="image/jpeg,image/jpg,image/png"
                                                            disabled
                                                        />
                                                    </label> */}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-8 col-md-12">
                                            <div className="mt-3 mb-3">
                                                <h4 className="text-primary">{employee.FirstName} {employee.MiddleName} {employee.LastName}</h4>
                                                <h5 className="text-secondary">{employee.EmployeeId}</h5>
                                                <p>Since {new Date(employee.DateOfJoining).toLocaleDateString('en-GB', {
                                                    day: '2-digit',
                                                    month: 'long',
                                                    year: 'numeric'
                                                })}</p>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-md-6 col-lg-6 col-sm-12">
                                                    <small className="form-text text-muted mb-2">Email</small>
                                                    <h6>{employee.OfficialEmail}</h6>
                                                </div>
                                                <div className="col-md-6 col-lg-6 col-sm-12">
                                                    <small className="form-text text-muted mb-2">Contact Number</small>
                                                    <h6>{employee.ContactNumber}</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="row">
                                        <div className="col-md-4 col-lg-4 col-sm-6">
                                            <small className="form-text text-muted mb-2">Employment Type</small>
                                            <h6>{employee.EmployeeType}</h6>
                                        </div>
                                        <div className="col-md-4 col-lg-4 col-sm-6">
                                            <small className="form-text text-muted mb-2">Department</small>
                                            <h6>{employee.Department}</h6>
                                        </div>
                                        <div className="col-md-4 col-lg-4 col-sm-6">
                                            <small className="form-text text-muted mb-2">Designation</small>
                                            <h6>{employee.Designation}</h6>
                                        </div>
                                        <div className="col-md-4 col-lg-4 col-sm-6">
                                            <small className="form-text text-muted mb-2">User Access</small>
                                            <h6>{employee.UserAccessLevel}</h6>
                                        </div>
                                        <div className="col-md-4 col-lg-4 col-sm-6">
                                            <small className="form-text text-muted mb-2">Date of Birth</small>
                                            <h6>{moment(employee.DateOfBirth).format("DD-MM-YYYY")}</h6>
                                        </div>
                                        <div className="col-md-4 col-lg-4 col-sm-6">
                                            <small className="form-text text-muted mb-2">Blood Group</small>
                                            <h6>{employee.BloodGroup}</h6>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body text-center">
                                    <p>Profile completion percentage</p>
                                    <div className="row justify-content-center mb-3">
                                        <div className="col-7">
                                            <div className="progress">
                                                <div
                                                    className={`progress-bar progress-bar-striped progress-bar-animated ${completionPercentage === 100 ? 'bg-success' : 'bg-secondary'}`}
                                                    role="progressbar"
                                                    style={{ width: `${completionPercentage}%` }}
                                                    aria-valuenow={completionPercentage}
                                                    aria-valuemin="0"
                                                    aria-valuemax="100"
                                                >
                                                    {completionPercentage}%
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <p>Use below link to fill all required information.</p>
                                    <Link to={'/PersonalInformation'}>
                                        <i className="ri-contacts-book-3-line"></i> Personal Information
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="card ww-app-bg">
                                <div className="card-body">
                                    <span><i className="ri-fingerprint-line"></i></span>
                                </div>
                            </div>
                            <div className="card mb-4">
                                <div className="card-body">
                                    <h4 className="mb-2">Reset Password</h4>
                                    <p>Enter the below details to reset your password.</p>
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-lg-12 col-md-4">
                                                <div className="floating-label form-group">
                                                    <label>Old Password</label>
                                                    <input
                                                        className="floating-input form-control"
                                                        type="password"
                                                        value={oldPassword}
                                                        onChange={(e) => setOldPassword(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-12 col-md-4">
                                                <div className="floating-label form-group">
                                                    <label>New Password</label>
                                                    <input
                                                        className="floating-input form-control"
                                                        type="password"
                                                        value={newPassword}
                                                        onChange={(e) => setNewPassword(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-12 col-md-4">
                                                <div className="floating-label form-group">
                                                    <label>Confirm Password</label>
                                                    <input
                                                        className="floating-input form-control"
                                                        type="password"
                                                        value={confirmPassword}
                                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mt-3">
                                            <div className="col-lg-12 text-center">
                                                <button type="reset" className="btn btn-light mr-1" onClick={handleClear}>Clear</button>
                                                <button type="submit" className="btn btn-primary">
                                                    Submit <i className="ri-checkbox-circle-line"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    );
};

export default Profile;

